import {
  AddSourceRequest,
  ListSourcesResponse,
  listSourcesResponseSchema,
  sourcePath,
  SOURCES_PATH,
  SourceSite,
  sourceSiteSchema,
} from '@quizdb/common';
import { quizdbApi } from '../api/quizdbApi';

/** The source sites' endpoints (QZ-D58). */
export const sourceApi = quizdbApi.injectEndpoints({
  endpoints: (builder) => ({
    listSources: builder.query<ListSourcesResponse, void>({
      query: () => SOURCES_PATH,
      transformResponse: (response: unknown) => listSourcesResponseSchema.parse(response),
      providesTags: ['SourceList'],
    }),
    addSource: builder.mutation<SourceSite, AddSourceRequest>({
      query: (request) => ({ url: SOURCES_PATH, method: 'POST', body: request }),
      transformResponse: (response: unknown) => sourceSiteSchema.parse(response),
      invalidatesTags: ['SourceList'],
    }),
    removeSource: builder.mutation<void, string>({
      // The API answers 204, so there is nothing to parse.
      query: (domain) => ({ url: sourcePath(domain), method: 'DELETE' }),
      invalidatesTags: ['SourceList'],
    }),
  }),
});

export const { useListSourcesQuery, useAddSourceMutation, useRemoveSourceMutation } = sourceApi;
